export default __webpack_public_path__ + "static/media/icon_medium.41e0ae3d.svg";